/* eslint-disable jsx-a11y/anchor-is-valid */
import { FC, useState } from 'react'
import { KTSVG } from '../../helpers'
import { LanguageHelp, getConfig } from '../../helpers/LanguageHelper'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import clsx from 'clsx'

export class TermsOfUseDto { Password = ''; ConfirmPassword = ''; }

const TermsOfUseModal: FC = ({ }) => {
  const lang = getConfig()
  const [isPasswordShow, setIsPasswordShow] = useState(false)

  const termsOfUseSchema = Yup.object().shape({
    Password: Yup.string()
      .min(8, LanguageHelp('Must contain 8 characters!'))
      .max(25, LanguageHelp('Must contain no more than 25 characters!'))
      .matches(/^(?=.*[\!\@\#\$\%\^\'\&\*\_\+\=\|\;\:\,\.\~\-])/, LanguageHelp("One special character required! -> !@#$%^'&*-_+=|;:,.~"))
      .matches(/^(?=.*[0-9])/, LanguageHelp("One special character required!"))
      .matches(/^(?=.*[a-z])/, LanguageHelp("One lowercase required!"))
      .matches(/^(?=.*[A-Z])/, LanguageHelp("One uppercase required!"))
      .required(LanguageHelp('Password is required')),
    ConfirmPassword: Yup.string()
      .required(LanguageHelp('Password confirmation is required'))
      .when('Password', {
        is: (val: string) => (val && val.length > 0 ? true : false),
        then: Yup.string().oneOf([Yup.ref('Password')], LanguageHelp("The passwords you entered do not match.")),
      }),
  })

  const [objectTermsOfUseDto] = useState(new TermsOfUseDto())

  const formik = useFormik({
    initialValues: objectTermsOfUseDto,
    validationSchema: termsOfUseSchema,
    onSubmit: async (values, { setSubmitting }) => {
      try {
      } catch (ex) {
        if (ex instanceof Error) {
          toast.error(LanguageHelp(ex.message));
        } else {
          console.log("Unexpected error", ex);
        }
      } finally {
        setSubmitting(false)
        window.location.reload()
      }
    },
  })

  return (
    <div className='modal fade' id='kt_modal_termsOfUse' aria-hidden='true'>
      <div className='modal-dialog modal-xl'>
        <div className='modal-content rounded'>
          <div>
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bolder'>{LanguageHelp('Terms of Use')}</h2>
              {/* end::Modal title */}
              {/* begin::Close */}
              <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>
          </div>
          <div className='modal-header justify-content-end border-0 pb-0'>

            <div className="container mt-5">
              <h1 className="mb-4">{LanguageHelp('1. PERSONAL DATA PROTECTION NOTICE (KVKK)')}</h1>
              <p><strong>{LanguageHelp('DATA CONTROLLER:')}</strong> VDSoftware Teknoloji A.Ş.</p>
              <p><strong>{LanguageHelp('Address:')}</strong> Sanayi Mahallesi Teknopark Bulvarı No:1/4C İç Kapı No:Z08 Pendik-Istanbul</p>
              {/* <p><strong>{LanguageHelp('Tax ID No:')}</strong> 9240966034 | <strong>{LanguageHelp('Tax Office:')}</strong> Pendik</p> */}
              <p><strong>{LanguageHelp('Contact:')}</strong> info@aisenseus.net — veli@aisenseus.net </p>

              <h2>{LanguageHelp('1.1. Purpose and Legal Basis of Personal Data Processing')}</h2>
              <p>{LanguageHelp('Your personal data are processed for the following purposes;')}</p>
              <ul>
                <li>{LanguageHelp('Analysis of data collected by artificial intelligence from sources such as social media, blogs, news sites, and forums related to our customers and competitors,')}</li>
                <li>{LanguageHelp('Sentiment analysis, trend reporting, and competitive strategy development,')}</li>
                <li>{LanguageHelp('Measuring customer satisfaction and optimizing marketing activities.')}</li>
              </ul>
              <p><strong>{LanguageHelp('Legal Grounds:')}</strong></p>
              <ul>
                <li>{LanguageHelp('KVKK Art. 5/2(c): "Legitimate interest of the data controller" (competition analysis and service development),')}</li>
                <li>{LanguageHelp('KVKK Art. 5/2(f): "Data processing is mandatory for establishing, exercising, or protecting a right" (evidence in legal disputes),')}</li>
                <li>{LanguageHelp('Explicit Consent (for sharing analysis results with the customer and marketing purposes).')}</li>
              </ul>

              <h2>{LanguageHelp('1.2. Categories of Processed Data')}</h2>
              <table className="table">
                <thead>
                  <tr>
                    <th>{LanguageHelp('Data Type')}</th>
                    <th>{LanguageHelp('Examples')}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{LanguageHelp('Identification Data')}</td>
                    <td>{LanguageHelp('Social media username, profile information (anonymized)')}</td>
                  </tr>
                  <tr>
                    <td>{LanguageHelp('Contact Data')}</td>
                    <td>{LanguageHelp('Email address, IP address, device information')}</td>
                  </tr>
                  <tr>
                    <td>{LanguageHelp('User Behavior Data')}</td>
                    <td>{LanguageHelp('Comments, posts, likes, interaction durations, trend participation')}</td>
                  </tr>
                  <tr>
                    <td>{LanguageHelp('Analytical Data')}</td>
                    <td>{LanguageHelp('Sentiment scores generated by AI, competitor comparison matrices')}</td>
                  </tr>
                </tbody>
              </table>

              <h2>{LanguageHelp('1.3. Data Transfer and Retention')}</h2>
              <p><strong>{LanguageHelp('Data Transfer:')}</strong></p>
              <ul>
                <li>{LanguageHelp('To our customers: anonymized data is shared in analysis reports.')}</li>
                <li>{LanguageHelp('International Transfer: Data may be processed on AWS and Azure servers located in the United States and Europe (with adequate protection commitments per KVKK Art. 9).')}</li>
              </ul>
              <p><strong>{LanguageHelp('Retention Period:')}</strong></p>
              <ul>
                <li>{LanguageHelp('2 years after analysis completion (in compliance with Turkish Commercial Code Art. 82).')}</li>
                <li>{LanguageHelp('Data is not deleted in case of legal obligations (Criminal Procedure Code Art. 339).')}</li>
              </ul>

              <h2>{LanguageHelp('1.4. Data Subject Rights (KVKK Art. 11)')}</h2>
              <ul>
                <li>{LanguageHelp('Inquiry whether your data is processed,')}</li>
                <li>{LanguageHelp('Learn the purpose of processing,')}</li>
                <li>{LanguageHelp('Request whether data is transferred to third parties,')}</li>
                <li>{LanguageHelp('Request correction of incomplete or inaccurate data,')}</li>
                <li>{LanguageHelp('Request deletion or anonymization (requests after report publication do not affect the reports).')}</li>
              </ul>
              <p><strong>{LanguageHelp('Application Method:')}</strong> {LanguageHelp('You can submit your requests with identity verification (Turkish ID Number or signed petition) to kvkk@aisenseus.net. Responses will be provided within 30 days.')}</p>

              <h2>{LanguageHelp('1.5. Security Measures')}</h2>
              {/* <p><strong>{LanguageHelp('Technical Measures:')}</strong> {LanguageHelp('Database access limited with 2FA, data stored with AES-256 encryption.')}</p> */}
              <p><strong>{LanguageHelp('Administrative Measures:')}</strong> {LanguageHelp('Personnel trained on KVKK, data processing activities covered by NDA.')}</p>

              {/* --- GDPR Section Start --- */}

              <h1 className="mt-5 mb-4">{LanguageHelp('2. GDPR PRIVACY NOTICE')}</h1>
              <p><strong>{LanguageHelp('DATA CONTROLLER:')}</strong> VDSoftware Teknoloji A.Ş.</p>
              <p><strong>{LanguageHelp('Scope:')}</strong> {LanguageHelp('This notice covers the processing of personal data of citizens of the European Union (EU) and the European Economic Area (EEA).')}</p>

              <h2>{LanguageHelp('2.1. Purposes of Personal Data Processing')}</h2>
              <p>{LanguageHelp('Your personal data are processed for the following purposes;')}</p>
              <ul>
                <li>{LanguageHelp('Compliance with legal obligations,')}</li>
                <li>{LanguageHelp('Provision and improvement of our services,')}</li>
                <li>{LanguageHelp('Increasing customer satisfaction,')}</li>
                <li>{LanguageHelp('Optimizing marketing activities.')}</li>
              </ul>

              <h2>{LanguageHelp('2.2. Legal Bases')}</h2>
              <ul>
                <li>{LanguageHelp('GDPR Article 6(1)(a): Consent,')}</li>
                <li>{LanguageHelp('GDPR Article 6(1)(b): Performance of a contract,')}</li>
                <li>{LanguageHelp('GDPR Article 6(1)(c): Compliance with legal obligation,')}</li>
                <li>{LanguageHelp('GDPR Article 6(1)(f): Legitimate interests.')}</li>
              </ul>

              <h2>{LanguageHelp('2.3. Data Subject Rights')}</h2>
              <ul>
                <li>{LanguageHelp('Right to access personal data,')}</li>
                <li>{LanguageHelp('Right to request correction or deletion ("right to be forgotten"),')}</li>
                <li>{LanguageHelp('Right to restriction of processing or objection,')}</li>
                <li>{LanguageHelp('Right to data portability,')}</li>
                <li>{LanguageHelp('Right to withdraw consent,')}</li>
                <li>{LanguageHelp('Right to be informed about data processing,')}</li>
                <li>{LanguageHelp('Right to lodge a complaint with the data protection authority.')}</li>
              </ul>
              <p><strong>{LanguageHelp('Application Method:')}</strong> <a href="mailto:info@aisenseus.net">info@aisenseus.net</a> {LanguageHelp('You can submit your requests with identity verification.')}</p>

              <h2>{LanguageHelp('2.4. Data Transfers')}</h2>
              <p>{LanguageHelp('Your personal data may be transferred outside the EU under GDPR with appropriate safeguards, such as Standard Contractual Clauses or other mechanisms approved by the European Commission.')}</p>

              <h2>{LanguageHelp('2.5. Security Measures')}</h2>
              <p>{LanguageHelp('Both technical and administrative measures are applied to protect your data.')}</p>

              {/* --- GDPR Section End --- */}

              <h1 className="mt-5 mb-4">{LanguageHelp('3. DISTANCE SALES AGREEMENT')}</h1>
              <h2>{LanguageHelp('PARTIES:')}</h2>
              <p><strong>{LanguageHelp('SELLER:')}</strong> VDSoftware Teknoloji A.Ş. ({LanguageHelp('Address and tax information above')})</p>
              <p><strong>{LanguageHelp('BUYER:')}</strong> [{LanguageHelp('Customer Name/Title')}]</p>

              <h2>{LanguageHelp('2.1. Subject of the Agreement')}</h2>
              <p>{LanguageHelp('The seller provides the following services on a "pay-as-you-go" model:')}</p>
              <ul>
                <li>{LanguageHelp('Data Collection and Analysis Package: Pulling data from social media and digital platforms,')}</li>
                <li>{LanguageHelp('Premium Reporting: Monthly competitive analysis, brand reputation score.')}</li>
              </ul>

              <h2>{LanguageHelp('2.2. Price and Payment')}</h2>
              <p><strong>{LanguageHelp('Unit Price:')}</strong> {LanguageHelp('Prices on our website + 20% VAT (Price change rights reserved.)')}</p>

              <p>
                <div className='fs-6 text-600'>
                  {LanguageHelp('You can view prices here.')}
                  <a href='https://www.aisenseus.net/#_Pricing' target='_blank' className='text-gray-800 text-hover-primary' >
                    &nbsp;<KTSVG path='/media/icons/duotune/arrows/arr095.svg' className='svg-icon-2' />
                  </a>
                </div>
              </p>
              {/* <p><strong>{LanguageHelp('Payment Methods:')}</strong> Bank transfer/EFT (TRXX XXXX ...), credit card via Paratika,</p> */}
              <p><strong>{LanguageHelp('Invoice:')}</strong> {LanguageHelp('Sent via email within 24 hours after payment completion.')}</p>

              <h2>{LanguageHelp('2.3. Right of Withdrawal (Consumer Protection Law Art. 15)')}</h2>
              <p>{LanguageHelp('Since digital content is delivered instantly, the right of withdrawal cannot be exercised after service activation. Cancellation before activation can be requested via kvkk@vdsoftware.com.')}</p>

              <h2>{LanguageHelp('2.4. Liability and Warranty')}</h2>
              <p>{LanguageHelp('Seller is not responsible for obtaining legal permissions in data collection. For service interruptions exceeding 10% of total time, refunds will be made.')}</p>

              <h2>{LanguageHelp('2.5. Dispute Resolution')}</h2>
              <p>{LanguageHelp('Istanbul Anadolu Courts and Enforcement Offices have jurisdiction.')}</p>
              {/* <p><strong>{LanguageHelp('SIGNATURE:')}</strong> VDSoftware Teknoloji A.Ş. [{LanguageHelp('Authorized Signature and Stamp')}]</p> */}
              {/* <p><strong>{LanguageHelp('Customer:')}</strong> [{LanguageHelp('Name/Signature')}]</p> */}

              <h1 className="mt-5 mb-4">{LanguageHelp('3. TERMS OF USE AGREEMENT')}</h1>
              <h2>{LanguageHelp('PARTIES:')}</h2>
              <p><strong>{LanguageHelp('SERVICE PROVIDER:')}</strong> VDSoftware Teknoloji A.Ş.</p>
              <p><strong>{LanguageHelp('USER:')}</strong> [{LanguageHelp('Customer Name/Title')}]</p>

              <h2>{LanguageHelp('3.1. Definitions')}</h2>
              <p><strong>{LanguageHelp('API Integration:')}</strong> {LanguageHelp('Permission for VDSoftware to access user’s social media accounts.')}</p>
              <p><strong>{LanguageHelp('Analysis Report:')}</strong> {LanguageHelp('AI-generated competitive analysis customized for the user.')}</p>

              <h2>{LanguageHelp('3.2. Obligations of the Parties')}</h2>
              <p><strong>{LanguageHelp('VDSoftware:')}</strong></p>
              <ul>
                <li>{LanguageHelp('Collects and analyzes social media, news, and similar open-source data in compliance with the relevant platforms’ usage policies and applicable KVKK/GDPR regulations.')}</li>
                <li>{LanguageHelp('Processes the customer-provided private data sources (CRM, surveys, call center, chatbot, messages, emails, etc.) based solely on the assumption that the customer has obtained the necessary legal consents.')}</li>
                <li>{LanguageHelp('Performs monthly system maintenance (notifies the user if maintenance exceeds 4 hours).')}</li>
              </ul>
              <p><strong>{LanguageHelp('User:')}</strong></p>
              <ul>
                <li>{LanguageHelp('Is responsible for obtaining and providing explicit consent and other legal permissions related to the customer’s private data sources.')}</li>
                <li>{LanguageHelp('Keeps the prepared analysis reports confidential as trade secrets and uses them solely for internal purposes.')}</li>
              </ul>

              <h2>{LanguageHelp('3.3. Intellectual Property')}</h2>
              <p>{LanguageHelp('Analysis reports are copyrighted by VDSoftware. User may use reports for internal use only.')}</p>

              <h2>{LanguageHelp('3.4. AI Analysis Disclaimer')}</h2>
              <p>{LanguageHelp('All analytical outputs are generated by machine learning algorithms without human intervention.')}</p>
              <p>{LanguageHelp('Accuracy may vary based on data quality from source platforms.')}</p>
              <p>{LanguageHelp('VDSoftware shall not be liable for decisions made based on these analyses.')}</p>
              <p>{LanguageHelp('Users are responsible for validating critical findings through alternative methods.')}</p>

              <h2>{LanguageHelp('3.5. Customer and Competitor Analysis Legal Provisions')}</h2>
              <p><strong>{LanguageHelp('Data Collection and Processing Principles:')}</strong> {LanguageHelp('The analysis services provided by VDSoftware Technology Inc. involve data collection and processing of collected data is conducted under recognized legal bases for data processing including legitimate business interest, while strictly adhering to the principle of data minimization and applicable data protection regulations.')}</p>
              <p><strong>{LanguageHelp('Service Scope and Liability Limitations:')}</strong> {LanguageHelp('The analytical reports generated consist of automated outputs produced by artificial intelligence algorithms, containing statistical and probabilistic assessments. These reports do not represent definitive facts and are intended solely for strategic decision support purposes. VDSoftware Technology Inc. makes no warranties regarding the accuracy, timeliness, or completeness of the analysis results and shall not be held liable for any consequences arising from decisions made based on these reports.')}</p>
              <p><strong>{LanguageHelp('Party Obligations:')}</strong> {LanguageHelp('The Client warrants that the content requested for analysis does not infringe upon intellectual property rights or personal data protection rights of third parties. VDSoftware Technology Inc. is obligated to promptly execute necessary procedures in response to:')}</p>
              <ul>
                <li>{LanguageHelp('Valid legal requests from data subjects')}</li>
                <li>{LanguageHelp('Access restriction notifications from platform administrators')}</li>
                <li>{LanguageHelp('Copyright infringement claims under applicable laws')}</li>
                <li>{LanguageHelp('Content restricted by court order or platform policy shall be immediately excluded from the analysis scope.')}</li>
              </ul>
              <p><strong>{LanguageHelp('General Provisionss:')}</strong> {LanguageHelp('All outputs provided under this service are intended for lawful business intelligence purposes only. The parties agree to comply with all applicable regulations regarding unfair competition and commercial practices in their respective jurisdictions.')}</p>

              <h2>{LanguageHelp('3.6. Termination of Agreement')}</h2>
              <p><strong>{LanguageHelp('Termination Without Cause:')}</strong> {LanguageHelp('Parties may terminate the agreement with 30 days prior notice.')}</p>
              <p><strong>{LanguageHelp('Termination With Cause:')}</strong></p>
              <ul>
                <li>{LanguageHelp('VDSoftware terminates the agreement immediately in case of user’s KVKK violation,')}</li>
                <li>{LanguageHelp('User may terminate if VDSoftware fails to provide service continuously for more than 15 days.')}</li>
              </ul>

              <h2>{LanguageHelp('ADDITIONAL PROVISIONS')}</h2>
              <p><strong>{LanguageHelp('Confidentiality:')}</strong> {LanguageHelp('Parties shall not disclose trade secrets learned under this agreement to third parties.')}</p>
              <p><strong>{LanguageHelp('Effectiveness:')}</strong> {LanguageHelp('This agreement comes into effect when the user clicks the "I Accept" button in the customer panel.')}</p>
              <p><strong>{LanguageHelp('Legal Compliance:')}</strong> {LanguageHelp('The agreement complies with Turkish Code of Obligations Art. 19 and Law No. 6502.')}</p>
            </div>

          </div>

        </div></div>
    </div>
  )
}

export { TermsOfUseModal }
